export default {
  procedure: "Procedimento",
  procedures_protocols: "Procedimentos/Protocolos",
  add_protocol: "Cadastrar protocolo",
  update_protocol: "Atualizar protocolo",
  list_protocols: "Listar protocolos",
  list_of_protocols: "Lista de protocolos",
  select_procedure_occupation: "Selecione um procedimento e ocupação",
  binded: "Vinculado",
  procedure_occupation: "Procedimento e Ocupação",
};
